<div *ngIf="!hasFinishedLoading" class="comp-loader">
	<lib-loading></lib-loading>
</div>
<div class="dash-content" *ngIf="hasFinishedLoading">

  <app-cta-banner></app-cta-banner>
  
  <div id="widget-container-sm" class="dash-container-sm" (mouseover)="initDragScroll($event)">
    <div id="sm-widget-{{i}}" class="dash-widget-sm {{ (widget.id  && dragIdx != i) ? 'dash-widget-on' : '' }}" *ngFor="let widget of smallWidgets; let i = index">
      <app-widget [dragging]="draggedItem ? (dragIdx == i) : false" [widgetData]="widget" [widgetInfo]="smallWidgetsInfo[i]" [scrolling]="dragScrolling"></app-widget>
      <div class="widget-control" *ngIf="draggedItem ? (dragIdx != i) : true">
        <div id="add-widget-btn-{{i}}" class="widget-control-btn control-close" (click)="addWidgetsDropdown(i)" *ngIf="!widget.id">
          <lib-svg [icon]="'add_ico'"></lib-svg>
        </div>
        <div id="drag-widget-btn-{{i}}" class="widget-control-btn control-drag" (pointerdown)="startWidgetDrag($event, i)" *ngIf="widget.id">
          <lib-svg [icon]="'drag_ico'"></lib-svg>
        </div>
        <div id="remove-widget-btn-{{i}}" class="widget-control-btn control-close" (click)="removeWidget(i)" *ngIf="widget.id">
          <lib-svg [icon]="'close_ico'"></lib-svg>
        </div>
      </div>
      <div id="dash-widget-sm-{{i}}" class="drop-mask {{ (dragIdx == i) ? 'drop-mask-dragged-widget' : '' }}" *ngIf="dropMask"></div>
      <div class="widgets-dropdown" *ngIf="showWidgetsDropdown[i]">
        <div class="dropdown-content">
          <div id="dropdown-item-{{i}}-{{k}}" class="dropdown-item" *ngFor="let item of draggableSidemenuItems; let k = index" (click)="confirmAddWidgetDropdown(item, i)">
            <span>{{ item.card_title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="blank-sm-space-item"></div>
  </div>
  <div id="widget-container-md" class="dash-container-md">
    <div id="widget-md-{{i}}" class="dash-widget-md {{ widget.id ? 'dash-widget-on' : '' }}" *ngFor="let widget of mediumWidgets; let i = index">
      <app-widget [dragged]="false" [widgetData]="widget" [widgetInfo]="mediumWidgetsInfo[i]"></app-widget>
    </div>
    <div class="blank-md-space-item"></div>
  </div>
  <div class="widgets-dropdown-backdrop" *ngIf="showWidgetsBackdrop" (click)="cancelAddWidgetDropdown()"></div>
</div>

<div #dragContainer class="drag-container">
  <div #dragElement class="drag-element">
    <app-widget class="widget-container" [dragged]="true" [widgetData]="draggedItem" [widgetInfo]="draggedItemInfo" *ngIf="draggedType === 'widget' && draggedItem"></app-widget>
    <div class="widget-control">
      <div class="widget-control-btn control-drag">
        <lib-svg [icon]="'drag_ico'"></lib-svg>
      </div>
      <div class="widget-control-btn control-close">
        <lib-svg [icon]="'close_ico'"></lib-svg>
      </div>
    </div>
  </div>
  <div class="drag-mask" (pointermove)="moveDraggedWidget($event)" (pointerup)="finishWidgetDrag($event)"></div>
</div>
